// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1021":"8198a8a4","3853":"8198a8a4","4338":"8198a8a4","8286":"8198a8a4","8597":"8198a8a4","9245":"0c1eca38","9718":"fd812ab1"}[chunkId] + ".chunk.css";
};